/**

 * Client: modul Meniu — galerie fullscreen + etichetă buton.

 */

import { sanitizeImageSrc } from '../utils/url.js?v=82.86';
import { isAlfaTemplateActive, isCustomTemplateActive } from './client-template-style.js?v=82.86';
import { DEFAULT_MENU_LABEL } from './menu-module-admin.js?v=82.86';

import {

  buildGalleryZoomSlide,

  attachGallerySwipe

} from '../utils/image-gallery-zoom.js?v=82.86';



const MENU_GALLERY_MAX = 15;



let detachMenuOverlayListeners = null;

let menuOverlayKeyHandler = null;



export function getMenuLabel(settings) {

  const label = String(settings?.menuLabel || '').trim();

  return label || DEFAULT_MENU_LABEL;

}



export function getMenuImages(settings) {

  if (!Array.isArray(settings?.menuImages)) return [];

  return settings.menuImages

    .map((u) => String(u || '').trim())

    .filter(Boolean)

    .slice(0, MENU_GALLERY_MAX);

}



export function isMenuModuleAvailable(settings) {

  if (settings?.menuEnabled === false) return false;

  const url = String(settings?.menuUrl || '').trim();

  return !!(url || getMenuImages(settings).length > 0);

}



function closeMenuGalleryOverlay() {

  const overlay = document.getElementById('menuGalleryOverlay');

  if (!overlay) return;
  overlay.style.bottom = '';
  overlay.classList.remove('has-dock');

  overlay.setAttribute('hidden', '');

  overlay.classList.remove('is-open');

  overlay.setAttribute('aria-hidden', 'true');

  document.body.classList.remove('menu-gallery-open', 'menu-book-open', 'menu-book-drop');
  document.getElementById('clientPremiumBottomDock')?.style.removeProperty('--sj-book-drop');

  if (detachMenuOverlayListeners) {

    try {

      detachMenuOverlayListeners();

    } catch (_) {

      /* ignore */

    }

    detachMenuOverlayListeners = null;

  }

  if (menuOverlayKeyHandler) {

    document.removeEventListener('keydown', menuOverlayKeyHandler);

    menuOverlayKeyHandler = null;

  }

}



export function openMenuGalleryOverlay(settings) {

  import('../services/client-analytics.js?v=82.86')

    .then((m) => m.trackClientEvent('menu', 'gallery_open'))

    .catch(() => {});

  const overlay = document.getElementById('menuGalleryOverlay');

  const titleEl = document.getElementById('menuGalleryOverlayTitle');

  const track = document.getElementById('menuGalleryOverlayTrack');

  const dots = document.getElementById('menuGalleryOverlayDots');

  const viewport = document.getElementById('menuGalleryOverlayViewport');

  const closeBtn = document.getElementById('menuGalleryOverlayClose');

  const backdrop = document.getElementById('menuGalleryOverlayBackdrop');



  if (!overlay || !track || !dots || !viewport) return;



  const images = getMenuImages(settings);

  if (images.length === 0) return;



  const headline = getMenuLabel(settings);

  if (titleEl) titleEl.textContent = headline;



  track.replaceChildren();

  dots.replaceChildren();



  const zoomControllers = [];



  images.forEach((url) => {

    const safe = sanitizeImageSrc(url);

    if (!safe) return;

    const { slide, zoom } = buildGalleryZoomSlide(safe, {

      slideClass: 'menu-gallery__slide',

      imgClass: 'menu-gallery__img'

    });

    zoomControllers.push(zoom);

    track.appendChild(slide);

  });



  const n = track.children.length;

  if (n === 0) return;

  // „Carte”: paginile stau una peste alta și se întorc ca la o carte (swipe, săgeți sau buline)
  const slides = Array.from(track.children);
  viewport.classList.add('menu-book');
  track.style.width = '';
  track.style.transform = '';
  slides.forEach((slide, si) => {
    slide.style.flex = '';
    slide.classList.add('menu-book__page');
    slide.classList.toggle('is-cur', si === 0);
    const img = slide.querySelector('img');
    if (img) img.loading = 'eager';
  });
  overlay.classList.add('menu-gallery-overlay--book');
  // bara aplicației (Joy, Locație, WiFi…) rămâne vizibilă și apăsabilă sub meniu
  overlay.style.bottom = '';
  const dock = document.getElementById('clientPremiumBottomDock');
  const dcs = dock ? getComputedStyle(dock) : null;
  let dr = dock && dcs.display !== 'none' && dcs.visibility !== 'hidden' ? dock.getBoundingClientRect() : null;
  if (dr && dr.height > 30 && dr.height < 160 && dr.bottom >= window.innerHeight - 30 && dr.top > window.innerHeight * 0.6) {
    // bara coboară puțin (cât spațiu liber are dedesubt), ca meniul să aibă mai mult loc
    const gap = Math.max(0, Math.round(window.innerHeight - dr.bottom) - 4);
    const drop = dcs.position === 'fixed' ? Math.min(14, gap) : 0;
    if (drop > 0) {
      dock.style.setProperty('--sj-book-drop', `${drop}px`);
      document.body.classList.add('menu-book-drop');
      dr = dock.getBoundingClientRect();
    }
    overlay.style.bottom = `${Math.max(0, Math.round(window.innerHeight - dr.top))}px`;
    overlay.classList.add('has-dock');
    document.body.classList.add('menu-book-open');
  } else {
    overlay.classList.remove('has-dock');
  }
  // săgețile ‹ › stau jos, în colțurile paginii; „Pagina x din y” doar pentru cititoarele de ecran
  overlay.querySelector('.menu-book__bar')?.remove();
  const bar = viewport;
  let counter = viewport.querySelector('.menu-book__count');
  if (!counter) {
    counter = document.createElement('span');
    counter.className = 'menu-book__count';
    counter.setAttribute('aria-live', 'polite');
    viewport.appendChild(counter);
  }
  const reduceMotion = (() => { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) { return false; } })();
  const FLIP_MS = reduceMotion ? 1 : 620;

  let index = 0;
  let busy = false;
  let flipTimer = null;

  const resetAllZoom = () => {

    zoomControllers.forEach((z) => z.reset());

  };

  const paintUi = () => {
    Array.from(dots.children).forEach((dot, di) => {
      dot.classList.toggle('is-active', di === index);
    });
    counter.textContent = `Pagina ${index + 1} din ${n}`;
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === n - 1;
  };

  const bump = (dir) => {
    const cur = slides[index];
    cur.classList.remove('is-bump-next', 'is-bump-prev');
    void cur.offsetWidth;
    cur.classList.add(dir > 0 ? 'is-bump-next' : 'is-bump-prev');
  };

  const goTo = (i) => {
    if (busy) return;
    if (i < 0 || i >= n) { bump(i < 0 ? -1 : 1); return; }
    if (i === index) return;
    resetAllZoom();
    const from = slides[index];
    const to = slides[i];
    const forward = i > index;
    busy = true;
    slides.forEach((sl) => sl.classList.remove('is-under', 'is-flip-out', 'is-flip-in', 'is-bump-next', 'is-bump-prev'));
    if (forward) {
      // pagina curentă se ridică spre stânga și o descoperă pe următoarea
      to.classList.add('is-under');
      from.classList.add('is-flip-out');
    } else {
      // pagina anterioară revine peste cea curentă
      from.classList.add('is-under');
      from.classList.remove('is-cur');
      to.classList.add('is-cur', 'is-flip-in');
    }
    index = i;
    paintUi();
    clearTimeout(flipTimer);
    flipTimer = setTimeout(() => {
      slides.forEach((sl, si) => {
        sl.classList.remove('is-under', 'is-flip-out', 'is-flip-in');
        sl.classList.toggle('is-cur', si === index);
      });
      busy = false;
    }, FLIP_MS);
  };

  let prevBtn = bar.querySelector('.menu-book__nav--prev');
  let nextBtn = bar.querySelector('.menu-book__nav--next');
  if (!prevBtn) {
    prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'menu-book__nav menu-book__nav--prev';
    prevBtn.setAttribute('aria-label', 'Pagina anterioară');
    prevBtn.textContent = '‹';
    nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'menu-book__nav menu-book__nav--next';
    nextBtn.setAttribute('aria-label', 'Pagina următoare');
    nextBtn.textContent = '›';
    bar.prepend(prevBtn);
    bar.append(nextBtn);
  }
  prevBtn.hidden = n < 2;
  nextBtn.hidden = n < 2;
  const onPrev = (e) => { e.stopPropagation(); goTo(index - 1); };
  const onNext = (e) => { e.stopPropagation(); goTo(index + 1); };
  prevBtn.addEventListener('click', onPrev);
  nextBtn.addEventListener('click', onNext);



  for (let i = 0; i < n; i++) {

    const dot = document.createElement('button');

    dot.type = 'button';

    dot.className = 'menu-gallery__dot';

    dot.setAttribute('aria-label', `Imagine ${i + 1}`);

    dot.addEventListener('click', () => goTo(i));

    dots.appendChild(dot);

  }

  paintUi();



  const detachSwipe =

    n > 1

      ? attachGallerySwipe(viewport, {

          canSwipe: () => !zoomControllers[index]?.isZoomed?.(),

          onSwipePrev: () => goTo(index - 1),

          onSwipeNext: () => goTo(index + 1)

        })

      : () => {};



  const onClose = () => closeMenuGalleryOverlay();

  closeBtn?.addEventListener('click', onClose, { once: true });

  backdrop?.addEventListener('click', onClose, { once: true });



  menuOverlayKeyHandler = (e) => {

    if (e.key === 'Escape') closeMenuGalleryOverlay();
    else if (e.key === 'ArrowRight') goTo(index + 1);
    else if (e.key === 'ArrowLeft') goTo(index - 1);

  };

  document.addEventListener('keydown', menuOverlayKeyHandler);



  // apăsare pe bara aplicației: închidem meniul, acțiunea butonului merge mai departe
  const onDockClick = () => closeMenuGalleryOverlay();
  const dockEl = overlay.classList.contains('has-dock') ? document.getElementById('clientPremiumBottomDock') : null;
  dockEl?.addEventListener('click', onDockClick, true);

  detachMenuOverlayListeners = () => {

    detachSwipe();
    dockEl?.removeEventListener('click', onDockClick, true);
    clearTimeout(flipTimer);
    prevBtn.removeEventListener('click', onPrev);
    nextBtn.removeEventListener('click', onNext);

    zoomControllers.forEach((z) => z.destroy());

  };



  overlay.removeAttribute('hidden');

  overlay.classList.add('is-open');

  overlay.setAttribute('aria-hidden', 'false');

  // cu bara aplicației vizibilă nu punem clasa care o ascunde
  if (!overlay.classList.contains('has-dock')) document.body.classList.add('menu-gallery-open');

}



export function applyMenuModuleClientUI(settings) {

  const btn = document.getElementById('locationMenuBtn');

  const menuShell = document.querySelector('.client-premium-menu-shell');

  const labelEl = btn?.querySelector('.location-menu-btn__text');

  const logoEl = document.getElementById('clientMenuCardLogo');

  const logoFallback = menuShell?.querySelector('.client-premium-module-card__logo-fallback');

  if (!btn) return;



  if (!isMenuModuleAvailable(settings)) {
    if (!isAlfaTemplateActive() && !isCustomTemplateActive()) {
      btn.style.display = 'none';
    }
    return;
  }



  btn.style.display = 'flex';

  btn.setAttribute('aria-label', getMenuLabel(settings));

  if (labelEl) {

    labelEl.textContent = getMenuLabel(settings);

  }



  const logoUrl = sanitizeImageSrc(String(settings?.locationLogoURL || '').trim());

  if (logoEl) {

    if (logoUrl) {

      logoEl.src = logoUrl;

      logoEl.hidden = false;

      if (logoFallback) logoFallback.style.display = 'none';

    } else {

      logoEl.removeAttribute('src');

      logoEl.hidden = true;

      if (logoFallback) logoFallback.style.display = '';

    }

  }

}


